import { Button } from '@iheartjane/reefer';

import { BloomLink } from '@jane/bloom/components/bloomLink';

import styles from './dealQualifiedBanner.module.css';

type DealQualifiedBannerProps = {
  discountedAmount: string;
};

export const DealQualifiedBanner = ({
  discountedAmount,
}: DealQualifiedBannerProps) => {
  return (
    <div className={styles['dealQualifiedContainer']}>
      <div>High five! You saved {discountedAmount}</div>
      <div className={styles['dealQualifiedButtons']}>
        <BloomLink to="/" className={styles['dealQualifiedButton']}>
          <Button variant="tertiary" label="Go home" full />
        </BloomLink>
        <BloomLink to="/checkout" className={styles['dealQualifiedButton']}>
          <Button variant="primary" label="View bag" full />
        </BloomLink>
      </div>
    </div>
  );
};
